var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSunHorizon = function SvgIconSunHorizon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.594 2.874a1 1 0 0 1 1.308.539l.722 1.734a1 1 0 0 1-1.847.769L7.055 4.18a1 1 0 0 1 .54-1.307m-6.22 6.22a1 1 0 0 1 1.307-.54l1.735.723a1 1 0 1 1-.769 1.846l-1.734-.722a1 1 0 0 1-.54-1.307M22.087 10.4a1 1 0 0 0-.768-1.846l-1.735.722a1 1 0 1 0 .769 1.846zm-5.681-7.527a1 1 0 0 1 .539 1.307l-.722 1.735a1 1 0 1 1-1.846-.769l.721-1.734a1 1 0 0 1 1.308-.54M1.5 14a1 1 0 1 0 0 2h21a1 1 0 1 0 0-2h-4.626l.001-.123v-.002a5.875 5.875 0 0 0-11.75 0v.002q0 .062.002.123zm6.627 0h7.746l.002-.126A3.875 3.875 0 1 0 8.127 14M3.5 18.75a1 1 0 0 1 1-1h15a1 1 0 1 1 0 2h-15a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconSunHorizon;